"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_uniq_1 = __importDefault(require("lodash.uniq"));

function uniq(collection) {
  return lodash_uniq_1.default(collection);
}

exports.uniq = uniq;